import React from 'react';

function Header() {
  
    return (
      <header className="bg-warning">
        <h1 className="px-3 pt-2 font-weight-bolder animate__animated animate__bounce">Meme Generator</h1>
        <h5 className="px-3 py-2 font-weight-bold text-light bg-dark">React + Bootstrap Project</h5>
        
      </header>
    );
  
  }

export default Header;